import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes as Switch,
} from "react-router-dom";
import PrivateRoute from './components/privateRoute'

import { Provider as ReduxProvider } from "react-redux";
import reduxStore from "./redux/store";

// Auth
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";

// Client Dashboard
import ClientDashboard from "pages/ClientDashboard";

// Admin Dashboard
import AdminDashboard from "pages/AdminDashboard";

// Not Found
import NotFoundPage from "pages/NotFound";

import initApp from "./initApp";
initApp(reduxStore);

function App() {
  return (
    <ReduxProvider store={reduxStore}>
      <Router>
        <Switch>
          {/* Auth */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Client Dashboard */}
          <Route path="/dashboard/*" element={
            <PrivateRoute element={ClientDashboard} />
          } />

          {/* Admin Dashboard */}
          <Route path="/admin/*" element={
            <PrivateRoute element={AdminDashboard} isAdminRoute={true} />
          } />

          {/* Not Found */}
          <Route path="*" element={<NotFoundPage />} />
        </Switch>
      </Router>
    </ReduxProvider>
  );
}

export default App;
